import { periods, TransferMetricKey } from "./statisticsConfig";

export const formatNumber = (value?: number) => {
    const num = value || 0;
    return num.toLocaleString("ru-RU");
};

export const formatValue = (value?: number, isMoney?: boolean, currency = 'руб') => {
    if (isMoney) return `${formatNumber(value)} ${currency}.`;
    return formatNumber(value);
};

export const formatTransferMetricValue = (
    metricKey: TransferMetricKey,
    value: number,
    isMoney: boolean,
    purchaseAmountCurrency?: string,
    transferCurrency?: string,
    sendCurrency?: string
) => {
    if (metricKey === "purchase_amount") {
        const cur = purchaseAmountCurrency || "";
        return cur ? `${formatNumber(value)} ${cur}` : formatNumber(value);
    }

    if (metricKey === "transfer_amount") {
        const cur = transferCurrency || "";
        return cur ? `${formatNumber(value)} ${cur}` : formatNumber(value);
    }

    if (metricKey === "send_amount") {
        const cur = sendCurrency || "";
        return cur ? `${formatNumber(value)} ${cur}` : formatNumber(value);
    }

    if (metricKey === "profit_rub") {
        const cur = sendCurrency || "";
        return cur ? `${formatNumber(value)} ${cur}` : formatNumber(value);
    }


    return formatValue(value, isMoney);
};

export const buildGroupedData = (
    source: any,
    groupKey: "city" | "purchase_currency",
    fieldKey: TransferMetricKey
) => {
    const map = new Map<
        string,
        {
            groupValue: string;
            values: Record<string, number>;
        }
    >();

    periods.forEach(period => {
        const list = source?.[period.key] || [];
        list.forEach((row: any) => {
            const rawValue = row[groupKey];
            const groupValue = rawValue || (groupKey === "city" ? "Город не указан" : "Валюта не указана");

            if (!map.has(groupValue)) {
                map.set(groupValue, { groupValue, values: {} });
            }
            const current = map.get(groupValue)!;
            current.values[period.key] = row[fieldKey] || 0;
        });
    });

    return Array.from(map.values());
};


export const formatCompact = (value: number): string => {
    if (!value) return '0';
    const absValue = Math.abs(value);

    if (absValue >= 1000000) {
        return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }

    if (absValue >= 1000) {
        return (value / 1000).toFixed(0) + 'k';
    }

    return value.toString();
};

export const formatCurrency = (value: number, currency: string = ''): string => {
    const formatted = new Intl.NumberFormat('ru-RU').format(Math.round(value));
    return currency ? `${formatted} ${currency}` : formatted;
};


export const hexToRgb = (hex: string) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : { r: 39, g: 125, b: 255 }; // Дефолтный синий, если hex некорректный
};